module.exports = __webpack_public_path__ + "img/ts2.a956d012.png";